namespace Matrix.Data {
    export interface ListItemForm {
        ListItemCode: Serenity.StringEditor;
        ListItemText: Serenity.StringEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ListItemForm extends Serenity.PrefixedContext {
        static formKey = 'Data.ListItem';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ListItemForm.init)  {
                ListItemForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(ListItemForm, [
                    'ListItemCode', w0,
                    'ListItemText', w0,
                    'DefaultSortOrder', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
